import React from "react";

const CardPlanesPago = ({ cuota, monto, vencimiento }) => {
  let salida = new Date(vencimiento);
  const vencida = salida < new Date();
  return (
    <tr>
      <td>{cuota}</td>
      <td><b>${(+monto).toFixed(2)}</b></td>
      <td>
        <span className={vencida ? 'esen-chip esen-chip--danger' : 'esen-chip esen-chip--neutral'}>
          {salida.toLocaleDateString()}
        </span>
      </td>
    </tr>
  );
};

export default CardPlanesPago;
